import {
  DateRangePicker,
  SingleInputDateRangeField,
} from '@mui/x-date-pickers-pro';
import React from 'react';

interface FormComponentProps {
  error: any;
  helperText?: string;
  label?: string;
  name: string;
  onBlur?: any;
  onChange?: any;
  other?: object;
  placeholder: string;
  readonly?: boolean;
  required?: boolean;
  slotProps?: any;
  value?: any;
}

const FormComponent: React.FC<FormComponentProps> = (props) => {
  const {
    error,
    helperText = '',
    label,
    name,
    onBlur,
    onChange,
    other = {},
    placeholder,
    readonly = false,
    required = false,
    slotProps = {},
    value,
  } = props;

  return (
    <DateRangePicker
      value={value}
      defaultValue={value}
      onChange={onChange}
      onAccept={() => onBlur?.()}
      onClose={() => onBlur?.()}
      label={`${label}${required ? '*' : ''}`}
      readOnly={readonly}
      slots={{
        field: SingleInputDateRangeField,
      }}
      slotProps={{
        ...slotProps,
        field: {
          ...(slotProps.field ?? {}),
          onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
            slotProps.field?.onBlur?.(event);
            onBlur?.(event);
          },
        },
        textField: {
          fullWidth: true,
          error,
          name,
          onBlur,
          placeholder,
          helperText,
          ...(slotProps.textField ?? {}),
          slotProps: {
            ...slotProps.textField?.slotProps,
            htmlInput: {
              'data-testid': name,
              ...slotProps.textField?.slotProps?.htmlInput,
            },
          },
        },
      }}
      {...other}
    />
  );
};

export default FormComponent;
